import {useEffect, useState} from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import { IconClockTable, IconScheduleTable } from '../../../../../components/buttons/IconButtons';
import CustomChip from '../../../../../components/CustomChip';
import { POSITION_MODEL } from '../../../../../Helpers/PositionModel';
import {getDateFormat, getTimeFormat} from '../../../../../Apis/functions';
import {ACCESS_TYPE_MATERIAL_MODEL} from '../../Model/Models';
import TableFunction from '../../../../../components/table/TableFunction';
import { SimpleSearchWithId } from '../../../../../reduxToolkit/Search/SearchApi';
import { useDispatch } from 'react-redux';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { TABLES } from '../../../../../Apis/Tables';
import { useParams } from 'react-router-dom';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessLogSectionApp =() => {
    // Stores the ID of the table element used for rendering and DOM references.
    const [tableId, setTableId] = useState('tbl_alsp_access_log_material_equipment');
    const dispatch = useDispatch();
     const { id } = useParams();
    const option = `${TABLES.EQUIPMENT_ACCESS_LOG}`;

    // Stores the ID of the search input associated with this table.
    const [searchId, setSearchId] = useState('txt_alsp_search_access_log_material_equipment');
    const [searchResults, setSearchResults] = useState({ content: [], totalElements: 0 });

    // Returns table header elements required by the custom TableFunction.
    const getThead = () => {
        return [
            <CustomTh key='issue_date' classes='w-25' tableId={tableId}>
                {t('date')}
            </CustomTh>,
            <CustomTh key='employee' classes='w-25' tableId={tableId}>
                {t('employee')}
            </CustomTh>,
            <CustomTh key='guard' classes='w-25' tableId={tableId}>
                {t('guard')}
            </CustomTh>,
            <CustomTh key='type' classes='w-25' tableId={tableId}>
                {t('type')}
            </CustomTh>,
        ];
    };

    // Returns the table body rows and raw dataset.
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = searchResults?.content?.map((item, index) => {
            const accessType = ACCESS_TYPE_MATERIAL_MODEL[item?.accessType];

            return (
                <>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <IconScheduleTable
                                className={'mr-8px mb-1 icon-color-general-950 fs-14px ibl-font-w-600'}
                            />
                            <p className='fs-14px ibl-font-w-600'> {getDateFormat(item?.accessDate, false)}</p>
                        </div>
                        <div className={'d-flex'}>
                            <IconClockTable className={'mr-8px mb-1 icon-color-general-950 '} />
                            <p className='fs-14px ibl-font-w-600'>{getTimeFormat(item?.accessDate)}</p>
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.userFullName}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.guardFullName}</CustomTd>
                    <CustomTd>
                        <CustomChip
                            legend={t(accessType?.trans)}
                            background={accessType?.chipColor}
                            fontColor={accessType?.fontColor}
                            borderColor={accessType?.chipColor}
                            variant='compact'
                            icon={accessType?.Icon}
                            classNameIcon={`${accessType?.color} h-16px w-16px`}
                            iconPosition={POSITION_MODEL.RIGHT}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content,
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            userId: id
        });
        // Dispatch the search action and handle the response
        dispatch(SimpleSearchWithId({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    };

    // Extracts table rendering and pagination utilities from TableFunction.
    const { t, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = TableFunction({
        data: searchResults,
        labelRowsPerPage: 'access_logs_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,
        getData//New
    });

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage
    };
};

export default AccessLogSectionApp;
